// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VW1OG","content":"styles_content__rWMOL","title":"styles_title__mYZRt","right":"styles_right__Vg25H"};